export function setSiteTitle(title: string): void {
  document.title = title
}
